(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.PPResultsHeaderCopy = api;
})(typeof window !== 'undefined' ? window : globalThis, function() {
  'use strict';
  var FOCUS_PHRASES = {
    heart: 'looking after your heart health', sleep: 'feeling more rested', energy: 'having steadier energy',
    immunity: 'supporting your everyday immune health', bones_joints: 'supporting your bones and joints',
    skin: 'caring for your skin from within', hair: 'supporting healthy hair', nails: 'supporting healthy nails',
    digestion: 'supporting comfortable digestion', brain: 'maintaining clear focus',
    vision: 'looking after your long-term eye health', stress: 'feeling more balanced during stressful periods'
  };
  var SUMMARY_ENDING = 'Based on your answers, we’ve selected the supplements we believe are most relevant for those priorities. Start with your main recommendations below, then explore the additional options if you’d like more complete support.';
  function joinPhrases(phrases) {
    if (phrases.length === 1) return phrases[0];
    if (phrases.length === 2) return phrases[0] + ' and ' + phrases[1];
    return phrases.slice(0, -1).join(', ') + ', and ' + phrases[phrases.length - 1];
  }
  function buildSummary(answers) {
    var focusAreas = answers && answers.focus_areas;
    if (!Array.isArray(focusAreas)) focusAreas = focusAreas ? [focusAreas] : [];
    var phrases = focusAreas.slice(0, 3).map(function(area) { return FOCUS_PHRASES[area] || ''; }).filter(Boolean);
    if (!phrases.length) return 'You told us what matters most to you right now. ' + SUMMARY_ENDING;
    return 'You told us that ' + joinPhrases(phrases) + (phrases.length === 1 ? ' matters' : ' matter') + ' most to you. ' + SUMMARY_ENDING;
  }
  function getFirstName(name) { return String(name || '').trim().split(/\s+/)[0]; }
  function buildTitle(name) { var firstName = getFirstName(name); return 'Here is your personal supplement plan' + (firstName ? ', ' + firstName : ''); }
  return { buildSummary: buildSummary, buildTitle: buildTitle, getFirstName: getFirstName };
});
